import { musicPlatformConstants } from "../actions/constants/musicPlatformConstant";

type MusicPlatformDataState = {
	items: any[];
};

const initialMusicPlatformsData: MusicPlatformDataState = {
	items: [],
};

const musicPlatformData = (state = initialMusicPlatformsData, action: any) => {
	switch (action.type) {
		case musicPlatformConstants.MusicPlatformGetByfilterRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case musicPlatformConstants.MusicPlatformGetByfilterSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isListSuccess: true,
				items: action.payload,
			};
		case musicPlatformConstants.MusicPlatformGetByfilterFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: true,
				status: action.payload,
			};

		case musicPlatformConstants.MusicPlatformDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case musicPlatformConstants.MusicPlatformDetailSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDetailComplete: true,
				musicPlatformsInput: action.payload,
			};
		case musicPlatformConstants.MusicPlatformDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDetailComplete: true,
				status: action.payload,
			};

		case musicPlatformConstants.MusicPlatformDeleteRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case musicPlatformConstants.MusicPlatformDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDeleteCompleted: true,
				status: action.payload.status,
			};
		case musicPlatformConstants.MusicPlatformDeleteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDeleteCompleted: true,
				status: action.payload,
			};

		case musicPlatformConstants.MusicPlatformSaveRequest:
			return {
				...state,
				isLoading: true,
				isFormSubmit: true,
				isError: false,
				isSuccess: false,
				isSuccessSave: false,
			};
		case musicPlatformConstants.MusicPlatformSaveSuccess:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isError: false,
				isSuccess: true,
				isSuccessSave: true,
				status: action.payload.status,
			};
		case musicPlatformConstants.MusicPlatformSaveFailure:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isSuccess: false,
				isSuccessSave: false,
				isError: true,
				status: action.payload.status,
			};

		default:
			return state;
	}
};

export default musicPlatformData;
